import React, {useCallback} from 'react';
import {useSelector} from 'react-redux';
import cn from 'classnames';

import {useSetUI} from 'coreHooks';
import {selectHeaderUI} from 'coreStore/data/ui/index';
import {UIState} from 'coreStore/data/ui/types';
import {RootState} from 'coreStore/types';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';
import {useHeaderCtx} from 'brandComponents/Header/HeaderCtx';
import {useOpenedFlyouts} from 'brandHooks';

import {IFlyoutToggleButtonProps} from './IFlyoutToggleButton';

import styles from './FlyoutToggleButton.module.scss';

const FlyoutToggleButton = ({flyoutId, buttonContent, isDisabled = false, dataIds}: IFlyoutToggleButtonProps) => {
	const {managerRepository} = useGeneralProvider();
	const {handleNavigationVisibility} = useHeaderCtx();
	const {isOpen} = useOpenedFlyouts(flyoutId);
	const {isNavigationOpened} = useSelector<RootState, UIState['header']>((state) => selectHeaderUI(state));
	const setUI = useSetUI();

	const toggleFlyout = useCallback(() => {
		if (isDisabled) {
			return;
		}

		if (isNavigationOpened && handleNavigationVisibility) {
			handleNavigationVisibility();
		}

		if (flyoutId === 'login') {
			setUI.setUI({isWishlistClick: false});
		}

		managerRepository.getFlyoutsMgr().toggleFlyout(flyoutId);
	}, [isNavigationOpened, isDisabled]);

	return (
		<Button
			classNames={cn(styles['flyout-toggle__close-button'], {
				[styles['flyout-toggle__close-button--selected']]: isOpen
			})}
			dataIds={dataIds}
			onClick={toggleFlyout}
			variant="anything"
		>
			{buttonContent}
		</Button>
	);
};

export default FlyoutToggleButton;
